import React, { FC } from 'react'

// Constants
import { localStorageKeys } from '@sketch/constants'

// Utils
import { dateFormat, getParsedItem, setStringifiedItem } from '@sketch/utils'

// Components
import { Button } from '@sketch/components'

// Styles
import {
  Text,
  SketchLogoBlack,
  SketchLogoText,
  Modal,
} from './EducationWorkspaceApprovedModal.styles'

// Types
import { ModalInjectedProps } from 'containers/ModalManager'
interface EducationWorkspaceApprovedModalProps extends ModalInjectedProps {
  endDate: string
  workspaceId: string
}

const EducationWorkspaceApprovedModal: FC<EducationWorkspaceApprovedModalProps> = ({
  hideModal,
  endDate,
  workspaceId,
}) => {
  const date = dateFormat(new Date(endDate))

  const handleHideModal = () => {
    // Grab all dismissed workspace ID's from local storage
    const previouslyDismissedIDs =
      getParsedItem(localStorageKeys.dismissedEducationApprovedModal) ?? []

    const currentDismissedIDs = [...previouslyDismissedIDs, workspaceId]

    // Set the current workspace ID to the list of dismissed modals
    setStringifiedItem(
      localStorageKeys.dismissedEducationApprovedModal,
      currentDismissedIDs
    )
    hideModal()
  }

  return (
    <Modal onCancel={handleHideModal}>
      <Modal.Header>Your Education Workspace was Approved!</Modal.Header>
      <Modal.Body>
        <Text>
          Good news — your Education Workspace was approved and is ready to use.
          <span>
            <SketchLogoBlack width="18.78px" />{' '}
            <SketchLogoText>Sketch</SketchLogoText>
          </span>{' '}
          is now free until {date}. Enjoy!
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary-untinted" onClick={handleHideModal}>
          Done
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EducationWorkspaceApprovedModal
